export default __webpack_public_path__ + "media/fonts/latest_icons.woff";